export default __webpack_public_path__ + "static/media/17.c2a1a28e.jpg";